import BaseError from '../BaseError'

export class TimeoutError extends BaseError {
  errorCode: TimeoutErrorCode
  constructor(errorCode: TimeoutErrorCode) {
    super({ errorCode, message: '' })
    this.errorCode = errorCode
  }
}

type TimeoutErrorCode = 'UPDATE_TIMEOUT'
